import { Drawer } from "antd";
import styled from "styled-components";

export const WrapperModalDiscountCode = styled(Drawer)`
  .ant-drawer-body {
    overflow-y: auto;
  }
`;
